import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'
import CarouselArrow from './carouselArrow'
import CarouselItem from './carouselItem'

import 'slick-carousel/slick/slick.css'
import './slick-theme.css'
import './style.scss'

class Carousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.data && props.data.contentData
    }
  }

  componentDidMount(){
    this.setState({
      innerWidth: window.innerWidth
    })
  }

  render() {
    const hasMultipleItems = this.state.items && this.state.items.length > 1
    const layoutSettings = this.props.layout && this.props.layout.settings
    return <div className={`carousel ` + (_.get(this.props, "layout.settings.isHidden") ? "hide" : "")}>
      {this.state.items && this.state.items.length > 0 && 
        <Slider dots={hasMultipleItems} infinite={hasMultipleItems} arrows={hasMultipleItems} nextArrow={<CarouselArrow itemCount={this.state.items.length} />} prevArrow={<CarouselArrow itemCount={this.state.items.length} />} autoplay={hasMultipleItems} speed={750} cssEase="ease-in-out" autoplaySpeed={4000} lazyLoad={true}>
          {this.state.items.map((item, i) => <div key={i}>
            <CarouselItem layoutSettings={layoutSettings} item={item} maxWidth={this.state.innerWidth || 1000} />
          </div>)}
        </Slider>}
    </div>;
  }
}

export default Carousel
